import { ConfigurationCaseValidationSituationConfigurationResponse } from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/services/local-case-validation-situations.dto'
import { Nullable } from '@/shared/types/app.types'

export interface LocalCasesValidationSituationModalItemList {
    id: string
    text: string
}

export interface LocalCasesValidationSituationModalState {
    validationAction:{
        data: LocalCasesValidationSituationModalItemList[]
        selected: Nullable<LocalCasesValidationSituationModalItemList>
    }
    validationSituation:{
        data: LocalCasesValidationSituationModalItemList[]
        selected: Nullable<LocalCasesValidationSituationModalItemList>
    }
    selectedRow: Nullable<ConfigurationCaseValidationSituationConfigurationResponse>
}
export const initialLocalCasesValidationSituationsModalState =
    (): LocalCasesValidationSituationModalState => ({
        selectedRow: null,
        validationAction: {
            data: [],
            selected: null
        },
        validationSituation: {
            data: [],
            selected: null
        }
    })
